var SelectField = require('modules/select-field');
var Filters = require('modules/custom-filters');

function CardFilters(el) {
	var selectFieldEl = el.querySelector('.js-filter-dropdown'),
		selectFieldElMobile = selectFieldEl.querySelector('.js-field-mobile'),
		selectFieldElCurrent = selectFieldEl.querySelector('[data-field-current]'),
		filterEl = el.querySelector('.js-card-filters'),
		selectComponent = new SelectField(selectFieldEl),
		filtersComponent = new Filters(filterEl);

	selectFieldElCurrent.innerHTML = selectFieldElMobile.querySelector('option').innerHTML;
	selectFieldElMobile.selectedIndex = 0;
	filtersComponent.filterByValue(selectFieldElMobile.value);
	selectComponent.onChange(filtersComponent.filterByValue.bind(filtersComponent));
}
module.exports = CardFilters;
